var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignmentBlueLarg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "assignment_blue_larg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4196",
    "data-name": "Path 4196",
    d: "M0,0H65V65H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4197",
    "data-name": "Path 4197",
    d: "M13.833,38.917H32.792v5.417H13.833Zm0-10.833H40.917V33.5H13.833Zm0-10.833H40.917v5.417H13.833Zm32.5-10.833H35.012a8.093,8.093,0,0,0-15.275,0H8.417a4.744,4.744,0,0,0-1.083.108,5.472,5.472,0,0,0-3.9,3.223A5.217,5.217,0,0,0,3,11.833V49.75a5.556,5.556,0,0,0,.433,2.113A5.74,5.74,0,0,0,4.6,53.6a5.438,5.438,0,0,0,2.735,1.49,7.028,7.028,0,0,0,1.083.081H46.333A5.433,5.433,0,0,0,51.75,49.75V11.833A5.433,5.433,0,0,0,46.333,6.417ZM27.375,5.74a2.031,2.031,0,1,1-2.031,2.031A2.046,2.046,0,0,1,27.375,5.74ZM46.333,49.75H8.417V11.833H46.333Z",
    transform: "translate(5.125 1.708)",
    fill: "#0078d7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentBlueLarg);
export default __webpack_public_path__ + "static/media/assignment_blue_larg.56c0c19ad5b9c8341f04be0e9b566688.svg";
export { ForwardRef as ReactComponent };